import React from 'react';
import withPaymentV2FloatCta from '@catalogo/service-americanas-product/src/hocs/payment-v2-float-cta';
import BuyButton from '@catalogo/ui-americanas-mobile-buy-button';
import { Price } from './components/price';
import { SecondaryButton } from './components/secondary-button';
import { Container, ButtonsWrapper, CashbackText, PriceWrapper } from './styles';

export const FloatAreaButton = ({
  buyTogetherPriceText,
  mainPayment,
  international,
  currentSku,
  productId,
  customer,
  history,
  isPreSale,
  isO2O,
  enableAme,
  experiment,
  offer,
  isWeddingList,
  hasSecondaryButton,
  cashbackText,
  defaultPriceText,
  paymentInstallmentText,
  discountProgressiveExperiment,
  servicePDPinfoForWarranty,
}) => {
  if (!offer) {
    return null;
  }

  const hasPaymentConditionText = !!mainPayment?.paymentConditionText;
  const hasPaymentInstallmentText = !!paymentInstallmentText;

  return (
    <Container>
      <PriceWrapper>
        <Price
          mainPayment={mainPayment}
          defaultPriceText={defaultPriceText}
          international={international}
          buyTogetherPriceText={buyTogetherPriceText}
          paymentInstallmentText={paymentInstallmentText}
          hasPaymentConditionText={hasPaymentConditionText}
        />
      </PriceWrapper>
      {!!cashbackText && (
        <PriceWrapper>
          <CashbackText
            as="p"
            $isSecondLine={hasPaymentConditionText || hasPaymentInstallmentText}
            dangerouslySetInnerHTML={{ __html: cashbackText }}
          />
        </PriceWrapper>
      )}
      <ButtonsWrapper $hasSecondaryButton={hasSecondaryButton}>
        <SecondaryButton
          enableAme={enableAme}
          isWeddingList={isWeddingList}
          currentSku={currentSku}
          customer={customer}
          history={history}
        />
        <BuyButton
          fullWidth={!hasSecondaryButton}
          isO2O={isO2O}
          productId={productId}
          currentSku={currentSku}
          isPreSale={isPreSale}
          experiment={experiment}
          discountProgressiveExperiment={discountProgressiveExperiment}
          servicePDPinfoForWarranty={servicePDPinfoForWarranty}
          history={history}
        />
      </ButtonsWrapper>
    </Container>
  );
};

export default withPaymentV2FloatCta(FloatAreaButton);
